/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from './core/BaseHttpRequest';
import type { OpenAPIConfig } from './core/OpenAPI';
import { FetchHttpRequest } from './core/FetchHttpRequest';

import { AiToAiTestService } from './services/AiToAiTestService';
import { AufgabenService } from './services/AufgabenService';
import { AuswertungAufgabenUebersichtService } from './services/AuswertungAufgabenUebersichtService';
import { AuswertungUnteraufgabeService } from './services/AuswertungUnteraufgabeService';
import { AuthService } from './services/AuthService';
import { CallsService } from './services/CallsService';
import { DashboardService } from './services/DashboardService';
import { ErwartungswerteService } from './services/ErwartungswerteService';
import { IcpService } from './services/IcpService';
import { KontaktaufnahmeService } from './services/KontaktaufnahmeService';
import { KontakteService } from './services/KontakteService';
import { KontaktePromptInsertsService } from './services/KontaktePromptInsertsService';
import { MandantenService } from './services/MandantenService';
import { PhonenumbersService } from './services/PhonenumbersService';
import { PromptsService } from './services/PromptsService';
import { SchedulersService } from './services/SchedulersService';
import { SpeechModelService } from './services/SpeechModelService';
import { StimmenService } from './services/StimmenService';
import { SystemService } from './services/SystemService';
import { ToolsService } from './services/ToolsService';
import { UnteraufgabenService } from './services/UnteraufgabenService';

type HttpRequestConstructor = new (config: OpenAPIConfig) => BaseHttpRequest;

export class API {

  public readonly aiToAiTest: AiToAiTestService;
  public readonly aufgaben: AufgabenService;
  public readonly auswertungAufgabenUebersicht: AuswertungAufgabenUebersichtService;
  public readonly auswertungUnteraufgabe: AuswertungUnteraufgabeService;
  public readonly auth: AuthService;
  public readonly calls: CallsService;
  public readonly dashboard: DashboardService;
  public readonly erwartungswerte: ErwartungswerteService;
  public readonly icp: IcpService;
  public readonly kontaktaufnahme: KontaktaufnahmeService;
  public readonly kontakte: KontakteService;
  public readonly kontaktePromptInserts: KontaktePromptInsertsService;
  public readonly mandanten: MandantenService;
  public readonly phonenumbers: PhonenumbersService;
  public readonly prompts: PromptsService;
  public readonly schedulers: SchedulersService;
  public readonly speechModel: SpeechModelService;
  public readonly stimmen: StimmenService;
  public readonly system: SystemService;
  public readonly tools: ToolsService;
  public readonly unteraufgaben: UnteraufgabenService;

  public readonly request: BaseHttpRequest;

  constructor(config?: Partial<OpenAPIConfig>, HttpRequest: HttpRequestConstructor = FetchHttpRequest) {
    this.request = new HttpRequest({
      BASE: config?.BASE ?? 'https://guude.ai',
      VERSION: config?.VERSION ?? '1.0.0',
      WITH_CREDENTIALS: config?.WITH_CREDENTIALS ?? false,
      CREDENTIALS: config?.CREDENTIALS ?? 'include',
      TOKEN: config?.TOKEN,
      USERNAME: config?.USERNAME,
      PASSWORD: config?.PASSWORD,
      HEADERS: config?.HEADERS,
      ENCODE_PATH: config?.ENCODE_PATH,
    });

    this.aiToAiTest = new AiToAiTestService(this.request);
    this.aufgaben = new AufgabenService(this.request);
    this.auswertungAufgabenUebersicht = new AuswertungAufgabenUebersichtService(this.request);
    this.auswertungUnteraufgabe = new AuswertungUnteraufgabeService(this.request);
    this.auth = new AuthService(this.request);
    this.calls = new CallsService(this.request);
    this.dashboard = new DashboardService(this.request);
    this.erwartungswerte = new ErwartungswerteService(this.request);
    this.icp = new IcpService(this.request);
    this.kontaktaufnahme = new KontaktaufnahmeService(this.request);
    this.kontakte = new KontakteService(this.request);
    this.kontaktePromptInserts = new KontaktePromptInsertsService(this.request);
    this.mandanten = new MandantenService(this.request);
    this.phonenumbers = new PhonenumbersService(this.request);
    this.prompts = new PromptsService(this.request);
    this.schedulers = new SchedulersService(this.request);
    this.speechModel = new SpeechModelService(this.request);
    this.stimmen = new StimmenService(this.request);
    this.system = new SystemService(this.request);
    this.tools = new ToolsService(this.request);
    this.unteraufgaben = new UnteraufgabenService(this.request);
  }
}

